var _title, _polyline, _rect, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconGift = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon--gift",
  ref: svgRef
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Gift icon")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "20 12 20 22 4 22 4 12"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 7,
  width: 20,
  height: 5
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 22,
  x2: 12,
  y2: 7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconGift.dab71c3b.svg";
export { ForwardRef as ReactComponent };